// Dictionnaire de référence : toutes les autres langues doivent fournir exactement les mêmes clés (type Translations)
import community from './community/fr';

const fr = {
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    validate: 'Valider',
    back: 'Retour',
    ok: 'OK',
    edit: 'Modifier',
    delete: 'Supprimer',
    optional: 'Facultatif',
    email: 'E-mail',
    password: 'Mot de passe',
    emailPlaceholder: 'exemple@exemple.com',
    emailRequired: 'E-mail requis',
    emailInvalid: 'E-mail invalide',
    passwordRequired: 'Mot de passe requis',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    passwordsMismatch: 'Les mots de passe ne correspondent pas',
    errorOccurred: 'Une erreur est survenue',
    operationUnavailable: 'Opération impossible pour le moment.',
    sessionExpired: 'Votre session a expiré, merci de vous reconnecter.',
    welcome: 'Bienvenue sur Promodeep !',
    privacyAck: 'Vous affirmez avoir pris connaissance de notre',
    privacyPolicyLink: 'Politique de confidentialité.',
  },
  categories: {
    all: 'Tout',
    electro: 'High-Tech',
    videoGame: 'Consoles et jeux vidéo',
    fashion: 'Mode & Accessoires',
    cosmetic: 'Cosmétique & Bien-être',
    sport: 'Sport',
    family: 'Enfant & Bébé',
    home: 'Maison',
    animal: 'Animaux',
    trip: 'Voyages',
    mechanic: 'Auto Moto',
    finance: 'Banques, Finances & Assurances',
    gardenDIY: 'Jardin & Bricolage',
    service: 'Services',
    featuredBrand: 'Marques vedettes',
    training: 'Cultures & formations',
    deal: 'Forfaits',
    grocery: 'Courses & Épicerie',
    crypto: 'Crypto',
    free: 'Gratuit',
  },
  header: {
    enableNotifications: 'Activer les notifications',
    disableNotifications: 'Désactiver les notifications',
    search: 'Recherche',
    searchPlaceholder: 'Recherche...',
    extensionBanner: 'Ne manquez plus aucun deal ni code promo ! Installez notre extension de navigateur pour accéder à toutes nos offres lors de vos achats en ligne.',
    addToChrome: 'Ajouter à Chrome',
    menu: 'Menu',
    createAlert: 'Créer une alerte',
    pushEnabled: 'Notifications activées : vous recevrez les meilleurs deals',
    pushDisabled: 'Notifications désactivées',
    pushDenied: 'Notifications bloquées : autorisez-les dans les paramètres du site (icône à gauche de l\'adresse), puis réessayez',
    pushUnavailable: 'Notifications indisponibles pour le moment, réessayez dans quelques secondes',
    pushError: 'Impossible d\'activer les notifications',
    pushPrompt: 'Recevez les meilleurs deals et codes promo en notification, sans créer de compte',
    pushPromptAction: 'Activer',
    notificationsTitle: 'Notifications',
    notificationsEmpty: 'Aucune notification pour le moment. Activez les alertes pour recevoir les meilleurs deals.',
    notificationsPromoCode: 'Code promo',
    notificationsOpen: 'Ouvrir les notifications',
    loginOrSignup: 'Connexion ou inscription',
    myAccount: 'Mon compte',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    post: 'Poster',
    forYou: 'Bons plans',
    promoCodes: 'Codes promo',
    clubPoints: 'Club Points',
    promotions: 'Promotions',
    categories: 'Catégories',
  },
  footer: {
    commission: 'Lorsque vous cliquez sur un lien, nous sommes susceptibles de recevoir une commission.',
    company: 'Entreprise',
    contact: 'Contact',
    about: 'À propos de nous',
    legal: 'Légal',
    legalNotice: 'Mentions légales',
    privacyPolicy: 'Politique de confidentialité',
    cookiesPolicy: 'Politique d\'utilisation des cookies',
    terms: 'Conditions générales d\'utilisation',
    joinUs: 'Suivez-nous',
    socialEmail: 'E-mail',
    findApps: 'Retrouvez nos applications sur les stores',
    ourApps: 'Nos applications',
    rights: 'tous droits réservés.',
    backToTop: 'Haut de page',
    showFooter: 'Afficher le footer',
    hideFooter: 'Masquer le footer',
  },
  auth: {
    loginTitle: 'Connexion',
    signupTitle: 'Inscription',
    loginButton: 'Se connecter',
    forgotPassword: 'Mot de passe oublié ?',
    createAccount: 'Créer un compte',
    alreadyHaveAccount: 'Vous avez déjà un compte',
    loginFailed: 'Identifiant ou mot de passe incorrect',
    signupSuccess: 'Compte créé ! Vérifiez votre boîte mail pour valider votre compte avant de pouvoir vous connecter.',
    confirmPassword: 'Confirmer le mot de passe',
    confirmPasswordRequired: 'Confirmation du mot de passe requise',
    forgotTitle: 'Mot de passe oublié',
    forgotSuccess: 'Si un compte existe avec cet e-mail, un lien de réinitialisation vient de vous être envoyé. Vérifiez votre boîte mail.',
    forgotIntro: 'Saisissez votre e-mail, nous vous enverrons un lien pour choisir un nouveau mot de passe.',
    sendLink: 'Envoyer le lien',
    invalidLink: 'Lien invalide',
    resetInvalidLink: 'Ce lien de réinitialisation est invalide.',
    resetExpiredLink: 'Ce lien de réinitialisation est invalide ou a expiré.',
    resetTitle: 'Réinitialiser le mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    resetButton: 'Réinitialiser le mot de passe',
    resetSuccessTitle: 'Mot de passe réinitialisé !',
    resetSuccessText: 'Votre mot de passe a bien été mis à jour, vous pouvez maintenant vous connecter.',
    verifying: 'Validation de votre compte en cours...',
    verifiedTitle: 'Compte validé !',
    verifiedText: 'Votre compte a bien été validé, vous pouvez maintenant vous connecter.',
    verifyInvalidLink: 'Lien de validation invalide.',
    verifyExpiredLink: 'Ce lien de validation est invalide ou a expiré.',
  },
  password: {
    strength: 'Force du mot de passe :',
    faible: 'Faible',
    moyen: 'Moyen',
    fort: 'Fort',
    ruleLength: 'Au moins 8 caractères',
    ruleLowercase: 'Une lettre minuscule',
    ruleUppercase: 'Une lettre majuscule',
    ruleDigit: 'Un chiffre',
    ruleSpecial: 'Un caractère spécial',
  },
  newsletter: {
    title: 'Inscription à la newsletter',
    intro: 'Pour recevoir la newsletter PromoDeep et ne manquer aucune offre, renseignez votre adresse e-mail.',
    unsubscribeLink: 'Si vous ne souhaitez plus recevoir la newsletter, cliquez',
    here: 'ici',
    unsubscribeTitle: 'Désinscription de la newsletter',
    unsubscribeIntro: "Indiquez votre adresse e-mail : nous vous enverrons un lien pour gérer ou supprimer vos abonnements.",
    checkInbox: "C'est presque fini ! Nous venons de vous envoyer un e-mail : cliquez sur le lien qu'il contient pour confirmer votre inscription. Sans confirmation, vous ne recevrez rien.",
    doubleOptIn: "Vous recevrez un e-mail pour confirmer votre adresse ; rien ne vous sera envoyé avant cette confirmation.",
    unsubscribeLinkSent: "Si cette adresse est inscrite, un lien pour gérer ou supprimer vos abonnements vient de lui être envoyé.",
    confirming: "Confirmation en cours…",
    confirmedTitle: "Inscription confirmée, merci !",
    listNewsletter: "Newsletter PromoDeep (bons plans et codes promo)",
    listPartnerOffers: "Offres de nos partenaires, envoyées par PromoDeep",
    backHome: "Retour à l'accueil",
    confirmInvalid: "Ce lien de confirmation est invalide ou a expiré.",
    unsubscribeInvalid: "Ce lien de désinscription est invalide.",
    unsubscribeFor: "Abonnements de l'adresse {{email}}",
    unsubscribeDone: "C'est fait : votre choix est enregistré.",
    unsubscribeNewsletter: "Ne plus recevoir la newsletter",
    unsubscribePartnerOffers: "Ne plus recevoir les offres partenaires",
    unsubscribeAll: "Me désinscrire de tout",
    noSubscription: "Cette adresse ne reçoit plus aucun e-mail de PromoDeep.",
    resubscribeHint: "Vous pourrez vous réinscrire à tout moment depuis le site.",
  },
  consents: {
    newsletter: "J'accepte de recevoir la newsletter de PromoDeep (bons plans et codes promo), quotidienne ou hebdomadaire.",
    partnerOffers: "J'accepte de recevoir par e-mail des offres de partenaires de PromoDeep. Ces e-mails sont envoyés par PromoDeep : mon adresse n'est jamais transmise aux partenaires.",
    signupHint: "Facultatif. La validation de votre compte (lien envoyé par e-mail) confirmera aussi ces choix.",
    unsubscribeAnytime: "Désinscription possible à tout moment via le lien présent dans chaque e-mail ou dans vos paramètres.",
  },
  cookies: {
    title: "Cookies",
    banner: "Avec votre accord, nous utilisons des cookies de mesure d'audience (Google Analytics) et de publicité (Google AdSense, Google Ads). Vous pouvez accepter, refuser ou choisir par catégorie ; refuser n'empêche pas d'utiliser le site. Vous pourrez changer d'avis à tout moment via « Gérer mes cookies » en bas de page.",
    policyLink: "Politique de cookies",
    acceptAll: "Tout accepter",
    rejectAll: "Tout refuser",
    customize: "Personnaliser",
    preferencesTitle: "Préférences des cookies",
    preferencesIntro: "Choisissez les catégories que vous acceptez. Rien n'est activé sans votre accord, et votre choix est conservé 6 mois.",
    necessary: "Cookies strictement nécessaires",
    necessaryText: "Indispensables au fonctionnement du site (session de connexion, langue, thème, mémorisation de vos choix sur les cookies). Ils ne servent pas à vous suivre et ne peuvent pas être désactivés.",
    analytics: "Mesure d'audience",
    analyticsText: "Google Analytics nous indique comment le site est utilisé (pages vues, durée, provenance) pour l'améliorer. Cookies _ga, 13 mois maximum.",
    ads: "Publicité",
    adsText: "Google AdSense affiche des publicités et Google Ads mesure l'efficacité de nos campagnes. Google peut traiter ces données hors de l'Union européenne.",
    saveChoices: "Enregistrer mes choix",
    changeLater: "Vous pourrez modifier ce choix à tout moment depuis « Gérer mes cookies » en bas de page.",
    manage: "Gérer mes cookies",
  },
  // Recherche sans deal PromoDeep : offres des marchands partenaires (Awin, Amazon), composant external-search-results
  externalSearch: {
    title: 'Chez nos marchands partenaires',
    subtitle: 'Aucun deal PromoDeep pour « {{query}} » : voici les offres de nos marchands partenaires.',
    seeOn: 'Voir « {{query}} » sur {{merchant}}',
    loading: 'Recherche chez nos marchands partenaires…',
    disclosure: 'Liens affiliés : PromoDeep peut toucher une commission sur vos achats, sans surcoût pour vous.',
  },
  deals: {
    noContent: 'Il n\'y a actuellement aucun contenu à présenter',
    noContentHint: 'Vous pouvez essayer d\'autres termes de recherche pour trouver ce que vous cherchez !',
    expired: 'Expiré',
    expiresSoon: 'Expire bientôt',
    voteUp: 'Voter pour ce deal',
    voteDown: 'Voter contre ce deal',
    removeFavorite: 'Retirer des favoris',
    saveFavorite: 'Enregistrer ce deal',
    showPromoCode: 'Voir le code promo',
    codeLabel: 'Code',
    copied: 'copié',
    codeCopied: 'Code copié dans le presse-papier',
    copyAndUseCode: 'Copier & utiliser le code',
    seeOffer: 'Voir l\'offre',
    share: 'Partager',
    viewGrid: 'Affichage en grille',
    viewList: 'Affichage en liste',
    freeShipping: 'Gratuit',
    hotDeals: 'Deals les + hot',
    advertiserTitle: 'Codes promo & bons plans',
    comments: 'Commentaires ({{count}})',
    addComment: 'Ajouter un commentaire...',
    publish: 'Publier',
    edited: '(modifié)',
    editComment: 'Modifier le commentaire',
    deleteComment: 'Supprimer le commentaire',
    followMember: 'Suivre ce membre',
    unfollowMember: 'Ne plus suivre ce membre',
    ignoreMember: 'Ignorer ce membre',
    unignoreMember: 'Ne plus ignorer ce membre',
    hiddenComment: 'Commentaire masqué : vous ignorez ce membre.',
    noComments: 'Aucun commentaire pour le moment. Soyez le premier à réagir !',
    confirmDelete: 'Supprimer ce commentaire ?',
    publishFailed: 'Impossible de publier le commentaire pour le moment.',
    editForbidden: 'Vous ne pouvez modifier que vos propres commentaires.',
    deleteForbidden: 'Vous ne pouvez supprimer que vos propres commentaires.',
    editFailed: 'Impossible de modifier le commentaire pour le moment.',
    deleteFailed: 'Impossible de supprimer le commentaire pour le moment.',
  },
  dealDetail: {
    breadcrumb: 'Fil d\'Ariane',
    home: 'Accueil',
    notFound: 'Cette offre n\'existe plus ou a été retirée.',
    seeAllDeals: 'Voir tous les deals',
    expiresToday: 'Expire aujourd\'hui',
    expiresIn: 'Expire dans {{count}} j',
    seeAdvertiserDeals: 'Voir toutes les offres de ce marchand',
    partner: 'Partenaire PromoDeep',
    postedBy: 'Posté par {{pseudo}}',
    freeDelivery: 'Livraison gratuite',
    deliveryPrice: 'Livraison {{price}} €',
    views: '{{count}} vues',
    promoCode: 'Code promo',
    codeCopiedOfferOpened: 'Copié, offre ouverte',
    seeOfferAt: 'Voir l\'offre chez {{advertiser}}',
    save: 'Sauvegarder',
    saved: 'Sauvegardé',
    expiredNotice: 'Cette offre a expiré : le prix ou le code peuvent ne plus être valables.',
    about: 'À propos de cette offre',
    details: 'Détails',
    merchant: 'Marchand',
    category: 'Catégorie',
    brand: 'Marque',
    shippedFrom: 'Expédié depuis',
    addedOn: 'Publié le',
    expiresOn: 'Expire le',
    otherAdvertiserDeals: 'Autres offres de {{advertiser}}',
    allAdvertiserDeals: 'Toutes les offres de {{advertiser}}',
    sameCategory: 'Dans la même catégorie',
    linkCopied: 'Lien copié dans le presse-papier',
  },
  contact: {
    title: 'Contactez-nous',
    subject: 'Sujet :',
    chooseSubject: 'Choisissez votre sujet !',
    types: {
      partenariats: 'Partenariats',
      autre: 'Autre',
    },
    pseudo: 'Pseudo :',
    email: 'E-mail :',
    message: 'Message :',
    required: 'Ce champ est obligatoire.',
    minLength: 'Ce champ doit contenir au moins {{count}} caractère(s).',
    maxLength: 'Ce champ doit contenir au plus {{count}} caractères.',
    invalidEmail: 'Format d\'e-mail invalide.',
    send: 'Envoyer',
    thanks: 'Merci',
    thanksText: 'Nous traitons votre demande dans les plus brefs délais.',
  },
  about: {
    title: 'Promodeep – Ici les bons plans',
    whoWeAre: 'Qui sommes-nous ?',
    intro: 'Promodeep est un site qui cherche et partage les dernières offres imbattables sur les meilleures choses à acheter, faire, visiter et manger, en France et dans le monde.',
    heading1: 'Nous ne partageons que des promotions sur des choses que nous voudrions acheter pour nous-mêmes.',
    text1: 'Nous travaillons avec les meilleurs partenaires commerciaux et proposons des offres à des prix imbattables.',
    heading2: 'Nous voulons partager avec vous des offres chaque jour, tous les jours !',
    text2: 'Promodeep rend abordables les petits luxes de la vie : nous recherchons les meilleures expériences à des prix difficiles à battre pour les partager avec vous. Nous ne proposons que les meilleures offres en high-tech, événements, jeux vidéo, logiciels, formations, crypto, mode, cosmétique, maison, forfaits, voyages, auto-moto, bébé et famille, sport, spas, salons, magasins et grandes marques.',
  },
  pwa: {
    iosInstall: 'Pour installer cette application sur votre appareil, appuyez sur le bouton Menu puis sur « Sur l\'écran d\'accueil ».',
    updateAvailable: 'Une nouvelle version de PromoDeep est disponible.',
    reload: 'Recharger',
  },
  settings: {
    title: 'Paramètres',
    loginPrompt: 'Connectez-vous pour gérer les paramètres de votre compte.',
    loading: 'Chargement de vos paramètres…',
    loadError: 'Impossible de charger vos paramètres.',
    retry: 'Réessayer',
    saveFailed: 'L\'enregistrement a échoué',
    operationFailed: 'L\'opération a échoué',
    sections: {
      profil: 'Profil',
      preferences: 'Préférences',
      social: 'Connexion via réseau social',
      notifications: 'Notifications',
      subscriptions: 'Abonnements',
      members: 'Membres suivis / ignorés',
    },
    profile: {
      avatar: 'Votre avatar',
      replace: 'Remplacer',
      clear: 'Effacer',
      avatarHint: 'Optimisé pour les images carrées',
      pseudo: 'Votre pseudonyme',
      editPseudo: 'Modifier le pseudo',
      pseudoRule: 'Le changement de pseudo est possible une fois tous les 6 mois',
      nextPseudoChange: '(prochain changement possible le {{date}})',
      description: 'Votre description',
      editDescription: 'Modifier la description',
      email: 'Adresse e-mail associée',
      newEmail: 'Nouvelle adresse e-mail',
      currentPassword: 'Mot de passe actuel',
      emailHint: 'Un lien de validation sera envoyé à la nouvelle adresse ; il faudra la valider avant votre prochaine connexion.',
      editEmail: 'Modifier l\'e-mail',
      password: 'Votre mot de passe',
      newPassword: 'Nouveau mot de passe',
      confirmNewPassword: 'Confirmer le nouveau mot de passe',
      passwordHint: 'Au moins 8 caractères, une minuscule, une majuscule, un chiffre et un caractère spécial.',
      editPassword: 'Modifier le mot de passe',
      accountData: 'Données de compte',
      exportData: 'Générer mes données',
      deleteAccount: 'Supprimer mon compte',
      deleteHint: 'Vos commentaires seront anonymisés, vos favoris et votre abonnement à la newsletter supprimés.',
      deleteForever: 'Supprimer définitivement',
      deleteConfirm: 'Supprimer définitivement votre compte ? Cette action est irréversible.',
      pseudoSaved: 'Pseudo modifié',
      descriptionSaved: 'Description modifiée',
      emailSaved: 'E-mail modifié. Un lien de validation a été envoyé à la nouvelle adresse.',
      passwordSaved: 'Mot de passe modifié',
      accountDeleted: 'Votre compte a été supprimé',
      deleteFailed: 'La suppression a échoué',
      avatarSaved: 'Avatar mis à jour',
      avatarRemoved: 'Avatar supprimé',
      chooseImage: 'Veuillez choisir une image',
      imageUnreadable: 'Impossible de lire cette image',
      exportFailed: 'L\'export a échoué',
    },
    preferences: {
      language: 'Langue',
      languageHint: 'Par défaut, le site s\'affiche dans la langue de votre appareil.',
      deviceLanguage: 'Langue de l\'appareil ({{language}})',
      theme: 'Thème',
      themeAuto: 'Automatique (clair le jour, sombre la nuit)',
      themeLight: 'Clair',
      themeDark: 'Sombre',
      themeHint: 'Par défaut, le site s\'affiche en clair le jour (7h–19h) et en sombre la nuit.',
      homePage: 'Page d\'accueil par défaut',
      homePageOptions: {
        une: 'À la une',
        promotionCode: 'Codes promo',
      },
      saved: 'Préférences enregistrées',
      groups: {
        pagination: 'Pagination',
        widgets: 'Widgets',
        autoSubscribe: 'S\'abonner automatiquement',
        adultContent: 'Contenu adulte',
        privacy: 'Confidentialité',
      },
      options: {
        infiniteScroll: 'Activer le déroulement infini',
        widgetLastActivities: 'Afficher mes dernières activités sur la page d\'accueil',
        widgetHotDeals: 'Afficher les deals les + hot',
        widgetPopularCategories: 'Afficher les catégories populaires',
        widgetBestPromoCodes: 'Afficher les meilleurs codes promo',
        widgetDiscussions: 'Afficher les discussions',
        widgetNewsMain: 'Afficher les dernières actualités sur la page principale',
        widgetNewsCategories: 'Afficher les dernières actualités sur les pages des catégories',
        autoSubscribe: 'Recevoir par défaut des notifications de réponses à tous les posts que je commente',
        adultContent: 'Afficher le contenu pour adultes',
        allowFollow: 'Autoriser les membres à me suivre',
        allowPrivateMessages: 'Autoriser les membres à m\'écrire en privé',
        allowBrowsingData: 'Autoriser Promodeep à collecter des données de navigation',
      },
      hints: {
        adultContent: 'Sélectionnez cette option pour afficher le contenu réservé aux adultes. Par défaut, le contenu réservé aux adultes est masqué (hors catégories et recherche, où les images sont masquées).',
      },
    },
    social: {
      linkAccount: 'Lier votre compte',
      google: 'Connexion avec Google',
      apple: 'Connexion avec Apple',
      unavailable: 'La connexion via réseau social n\'est pas encore disponible sur Promodeep.',
    },
    notifications: {
      saved: 'Notifications enregistrées',
      emailOption: 'Envoyez-moi aussi une notification par e-mail',
      groups: {
        browser: 'Notifications dans le navigateur',
        general: 'Général',
        myDeals: 'Mes deals',
        followedDeals: 'Deals suivis',
        myComments: 'Mes commentaires',
        myInfo: 'Mes infos supplémentaires',
        club: 'Points Club',
        badges: 'Badges',
        followedMembers: 'Membres suivis',
        messages: 'Messages',
      },
      options: {
        browserMessage: 'Quand quelqu\'un m\'envoie un message',
        browserCall: "Quand quelqu'un m'appelle",
        generalMention: 'Quand quelqu\'un me mentionne dans un commentaire',
        dealVote: 'Quand quelqu\'un vote sur mon deal',
        dealComment: 'Quand quelqu\'un commente mon post',
        dealHot: 'Quand mon deal passe hot',
        dealInfoAdded: 'Quand quelqu\'un ajoute des infos à mon post',
        dealBeforeExpiration: 'Avant l\'expiration de mon deal',
        dealExpired: 'Quand mon post expire',
        dealReactivated: 'Quand mon deal expiré est réactivé',
        dealBeforeReactivation: 'Avant la réactivation de mon deal',
        dealMaybeExpired: 'Quand un de mes deals pourrait être expiré',
        dealStatsReady: 'Lorsque les statistiques du deal sont prêtes',
        followedDealComment: 'Quand quelqu\'un commente un post auquel je suis abonné(e)',
        followedDealInfoAdded: 'Quand quelqu\'un ajoute des infos à un post auquel je suis abonné(e)',
        commentReaction: 'Quand quelqu\'un réagit à mon commentaire',
        commentApproved: 'Quand mon commentaire est approuvé',
        commentReply: 'Quand quelqu\'un répond à mon commentaire',
        commentThreadReaction: 'Quand quelqu\'un réagit à un commentaire auquel j\'ai répondu',
        commentDeletedMerge: 'Lorsque mon commentaire est supprimé en raison d\'une fusion de deals',
        commentRemarkable: 'Quand mon commentaire devient remarquable',
        infoLiked: 'Quand quelqu\'un aime mes infos supplémentaires',
        clubLevelUp: 'Lorsque je passe à un niveau supérieur',
        clubRewardsLost: 'Lorsque je perds mes récompenses',
        clubCommentUseful: 'Quand mon commentaire devient utile',
        clubWeeklyVotes: 'Quand mes votes hebdomadaires me rapportent des points',
        clubReferralUsed: 'Lorsque mon code/lien de parrainage soumis est utilisé plusieurs fois',
        badgeEarned: 'Quand je gagne un badge',
        badgeSuperPoster: 'Quand j\'obtiens le statut de Super Poster',
        followedMemberPost: 'Quand un(e) membre que je suis poste un deal ou une discussion',
      },
    },
    subscriptions: {
      manage: 'Gérez vos abonnements',
      daily: 'Newsletter quotidienne',
      weekly: 'Newsletter hebdomadaire',
      unsubscribe: 'Se désabonner',
      update: 'Modifier mon abonnement',
      subscribe: 'S\'abonner',
      subscribedDaily: 'Vous êtes abonné(e) à la newsletter quotidienne sur {{email}}.',
      subscribedWeekly: 'Vous êtes abonné(e) à la newsletter hebdomadaire sur {{email}}.',
      noEmail: 'Aucune adresse e-mail n\'est associée à votre compte. Ajoutez-en une dans la section',
      noEmailEnd: 'pour recevoir la newsletter.',
      saved: 'Abonnement enregistré',
      unsubscribed: 'Vous êtes désabonné(e)',
      partnerOffersOn: "Vous recevrez les offres de nos partenaires",
      partnerOffersOff: "Vous ne recevrez plus les offres de nos partenaires",
      pending: "Un e-mail de confirmation est en attente : cliquez sur le lien reçu pour activer votre inscription.",
    },
    members: {
      following: 'Abonnements',
      ignored: 'Membres ignorés',
      select: 'Sélectionner {{pseudo}}',
      unfollow: 'Ne plus suivre',
      unfollowMember: 'Ne plus suivre {{pseudo}}',
      unfollowSelected: 'Ne plus suivre les membres sélectionnés',
      noFollowing: 'Vous ne suivez personne. Vous pouvez suivre un(e) membre depuis ses commentaires.',
      unignore: 'Ne plus ignorer',
      unignoreMember: 'Ne plus ignorer {{pseudo}}',
      unignoreSelected: 'Ne plus ignorer les membres sélectionnés',
      noIgnored: 'Vous n\'ignorez personne. Vous pouvez ignorer un(e) autre membre depuis ses commentaires.',
      listUpdated: 'Liste mise à jour',
    },
  },
  chat: {
    pushBanner: "Activez les notifications pour recevoir vos messages et vos appels quand l'appli est fermée. Vous recevrez aussi les alertes de bons plans.",
    pushActivate: "Activer",
    pushLater: "Plus tard",
    title: "Discussions",
    open: "Ouvrir les discussions",
    loginRequired: "Connectez-vous pour ajouter des amis et discuter avec eux en temps réel.",
    tabChats: "Discussions",
    tabRequests: "Demandes",
    tabSearch: "Ajouter",
    online: "En ligne",
    offline: "Hors ligne",
    typing: "écrit…",
    startConversation: "Dites bonjour 👋",
    you: "Vous : {{text}}",
    me: 'Vous',
    noFriends: "Vous n'avez pas encore d'amis. Recherchez des membres ou ajoutez-les depuis leurs commentaires.",
    findMembers: "Trouver des membres",
    received: "Reçues",
    sent: "Envoyées",
    accept: "Accepter",
    decline: "Refuser",
    pending: "En attente",
    cancelRequest: "Annuler la demande",
    noReceived: "Aucune demande reçue",
    noSent: "Aucune demande envoyée",
    searchPlaceholder: "Rechercher un membre par pseudo",
    searching: "Recherche…",
    searchHint: "Tapez au moins 2 caractères du pseudo",
    noResults: "Aucun membre trouvé",
    sendMessage: "Message",
    addFriend: "Ajouter",
    options: "Options",
    removeFriend: "Retirer des amis",
    removeFriendConfirm: "Retirer {{pseudo}} de vos amis ? Vous ne pourrez plus discuter ensemble.",
    friendRemoved: "{{pseudo}} a été retiré(e) de vos amis",
    loadOlder: "Messages précédents",
    loading: "Chargement…",
    emptyConversation: "Vous êtes maintenant amis avec {{pseudo}}. Envoyez le premier message !",
    seen: "Vu",
    messagePlaceholder: "Écrivez un message…",
    send: "Envoyer",
    selectConversation: "Choisissez une discussion ou ajoutez des amis pour commencer.",
    today: "Aujourd'hui",
    yesterday: "Hier",
    sendError: "Le message n'a pas pu être envoyé",
    requestSentTo: "Demande d'ami envoyée à {{pseudo}}",
    nowFriends: "Vous êtes maintenant amis avec {{pseudo}}",
    requestReceived: "{{pseudo}} vous a envoyé une demande d'ami",
    requestAccepted: "{{pseudo}} a accepté votre demande d'ami",
    newMessageFrom: "Nouveau message de {{pseudo}}",
    view: "Voir",
    sendMessageTo: "Envoyer un message à {{pseudo}}",
    acceptRequestFrom: "Accepter la demande d'ami de {{pseudo}}",
    requestPendingWith: "Demande d'ami envoyée à {{pseudo}}, en attente",
    addFriendNamed: "Ajouter {{pseudo}} en ami",
  },
  call: {
    audioCall: "Appel audio",
    videoCall: "Appel vidéo",
    withPeer: "Appel avec {{pseudo}}",
    incomingAudio: "Appel audio entrant…",
    incomingVideo: "Appel vidéo entrant…",
    calling: "Appel en cours…",
    connecting: "Connexion…",
    accept: "Décrocher",
    decline: "Refuser",
    hangUp: "Raccrocher",
    mute: "Couper le micro",
    unmute: "Réactiver le micro",
    cameraOff: "Couper la caméra",
    cameraOn: "Activer la caméra",
    offline: "{{pseudo}} n'est pas en ligne",
    busy: "{{pseudo}} est déjà en communication",
    declined: "{{pseudo}} a refusé l'appel",
    noAnswer: "{{pseudo}} ne répond pas",
    missed: "Appel manqué de {{pseudo}}",
    ended: "Appel terminé",
    peerDisconnected: "La communication avec {{pseudo}} a été coupée",
    connectionLost: "Connexion perdue, l'appel a été interrompu",
    connectionFailed: "Impossible d'établir la communication : le réseau bloque peut-être l'appel",
    mediaDenied: "Accès au micro refusé. Autorisez-le dans les paramètres du navigateur.",
    mediaDeniedVideo: "Accès au micro ou à la caméra refusé. Autorisez-les dans les paramètres du navigateur.",
    insecureContext: "Les appels nécessitent une connexion sécurisée (HTTPS)",
    unsupported: "Votre navigateur ne permet pas les appels",
    failed: "L'appel n'a pas pu être lancé",
  },
  // Colonne de droite : publicité, partenaires, actualités tech
  sidebar: {
    advertising: 'Publicité',
    partners: 'Nos partenaires',
    allMerchants: 'Tous les marchands',
    latestNews: 'Dernières actualités',
  },
  // Accueil mobile, barre du bas et menu des services
  mobileHome: {
    home: 'Accueil',
    shortcuts: 'Raccourcis',
    favorites: 'Favoris',
    merchants: 'Marchands',
    messages: 'Messages',
    newsletter: 'Newsletter',
    postLink: 'Poster un lien',
    contributions: 'Mes contributions',
    rewards: 'Récompenses',
    sectionDeals: 'Bons plans',
    sectionCommunity: 'Communauté',
    sectionInfo: 'Rester informé',
  },
  ...community,
};

export type Translations = typeof fr;
export default fr;
